// extracted by mini-css-extract-plugin
module.exports = {"heading":"Heading_heading__209rB","link":"Heading_link__hZJSV","icon":"Heading_icon__KXqnl"};